import { useAtomValue } from 'jotai'
import { usePermissions } from 'lib/rbac'
import { adminViewEnabledAtom } from '../manualTasksInbox/atoms'

/**
 * Whether Watchtower reads manual tasks from the admin endpoint
 * (`getAdminManualTasks`) rather than the assigned one. Shared by the summary
 * that reads the reviewable tasks and the list items that preload them, so the
 * preload always targets the same query the summary will read.
 */
export const useShouldUseAdminManualTasks = (): boolean => {
  const adminViewEnabled = useAtomValue(adminViewEnabledAtom)
  const { isAdmin } = usePermissions()

  return adminViewEnabled && isAdmin
}
